import type { GraphEntityType, GraphRelationType } from "@salesko/contracts";
import type { Dictionary } from "../i18n";

export function entityLabel(t: Dictionary, type: GraphEntityType) {
  switch (type) {
    case "person":
      return t.entities.person;
    case "organisation":
      return t.entities.organisation;
    case "event":
      return t.entities.event;
    case "opportunity":
      return t.entities.opportunity;
    case "note":
      return t.entities.note;
  }
}
export function entitySingularLabel(t: Dictionary, type: GraphEntityType) {
  switch (type) {
    case "person":
      return t.entities.personSingular;
    case "organisation":
      return t.entities.organisationSingular;
    case "event":
      return t.entities.eventSingular;
    case "opportunity":
      return t.entities.opportunitySingular;
    case "note":
      return t.entities.noteSingular;
  }
}

export function workspaceNavLabel(t: Dictionary, id: string) {
  switch (id) {
    case "overview":
      return t.nav.overview;
    case "graph":
      return t.nav.graph;
    case "people":
      return t.nav.people;
    case "companies":
      return t.nav.companies;
    case "events":
      return t.nav.events;
    case "schedule":
      return t.nav.schedule;
    case "signals":
      return t.nav.signals;
    case "current":
      return t.nav.current;
    case "privateAgent":
      return t.nav.privateAgent;
    default:
      return id;
  }
}

export function relationshipTypeLabel(t: Dictionary, type: GraphRelationType) {
  switch (type) {
    case "related_to":
      return t.detail.relationshipTypeRelatedTo;
    case "met_at":
      return t.detail.relationshipTypeMetAt;
    case "works_at":
      return t.detail.relationshipTypeWorksAt;
    case "attended":
      return t.detail.relationshipTypeAttended;
    case "introduced_by":
      return t.detail.relationshipTypeIntroducedBy;
    case "opportunity_at":
      return t.detail.relationshipTypeOpportunityAt;
    case "mentioned":
      return t.detail.relationshipTypeMentioned;
  }
}
